import { NewChallenge } from './NewChallenge';

export default NewChallenge;
